import {Inject, Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {
  TISA_WICKET_DICTS_URL,
  TISA_WICKET_URL,
  WICKET_REFRESH_TOKEN_KEY,
  WICKET_TOKEN_KEY,
} from '../tisa-wicket.providers';
import {Observable} from 'rxjs';
import {TokenResponse} from '@tisa-group/models/wicket/wicket-api-token-response';
import {LOCAL_STORAGE} from '@ng-web-apis/common';
import {WicketTokenData} from '@tisa-group/models';
import cryptoJS from 'crypto-js';

@Injectable({
  providedIn: 'root',
})
export class WicketLoginService {
  constructor(
    protected readonly httpClient: HttpClient,
    @Inject(TISA_WICKET_URL) readonly wicketUrl: string | (() => string),
    @Inject(LOCAL_STORAGE) readonly localStorage: Storage,
    @Inject(WICKET_TOKEN_KEY)
    private readonly _tokenStorageKey: string,
    @Inject(WICKET_REFRESH_TOKEN_KEY)
    private readonly _tokenRefreshStorageKey: string,
  ) {}

  fetchToken(hash: string, applicationSub: string): Observable<TokenResponse> {
    return this.httpClient.post<TokenResponse>(
      `${
        this.wicketUrl instanceof Function ? this.wicketUrl() : this.wicketUrl
      }/anonymous/token/get`,
      {
        fan_application_sub: applicationSub,
        hash,
      },
    );
  }

  saveTokenDataToLocalStorage(token: string, refreshToken: string) {
    this.localStorage.setItem(this._tokenRefreshStorageKey, refreshToken);
    this.localStorage.setItem(this._tokenStorageKey, token);
  }

  removeTokenDataToLocalStorage() {
    this.localStorage.removeItem(this._tokenRefreshStorageKey);
    this.localStorage.removeItem(this._tokenStorageKey);
  }

  getTokenDataToLocalStorage(): WicketTokenData | null {
    const token = this.localStorage.getItem(this._tokenStorageKey);
    const refreshToken = this.localStorage.getItem(this._tokenRefreshStorageKey);

    if (!token || !refreshToken) return null;

    return {
      id_token: token,
      refresh_token: refreshToken,
    };
  }

  decryptTokenData(encryptedTokenData: string): WicketTokenData {
    const decrypted = cryptoJS.AES.decrypt(encryptedTokenData, 'secret');

    const decryptedTokenData: WicketTokenData = JSON.parse(
      cryptoJS.enc.Latin1.stringify(decrypted),
    );

    return decryptedTokenData;
  }
}
